enum ErrorCode {
  NETWORK_ERROR = 'ERR_NETWORK',
}

export default ErrorCode;
